(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteMenu extends HTMLElement {
    connectedCallback() {
      this.menuToggle = this.querySelector('.mobile-menu-toggle');
      this.menu = this.querySelector('.mobile-menu');
      this.submenuToggles = this.querySelectorAll('.mobile-submenu-toggle');

      if (!this.menuToggle || !this.menu) return;

      this.menuToggle.addEventListener('click', () => {
        const isExpanded = this.menuToggle.getAttribute('aria-expanded') === 'true';
        this.menuToggle.setAttribute('aria-expanded', !isExpanded);
        this.menu.setAttribute('aria-hidden', isExpanded);
      });

      // Close menu when clicking outside
      document.addEventListener('click', (event) => {
        const isExpanded = this.menuToggle.getAttribute('aria-expanded') === 'true';
        if (isExpanded && !this.contains(event.target)) {
          this.menuToggle.setAttribute('aria-expanded', 'false');
          this.menu.setAttribute('aria-hidden', 'true');
        }
      });

      // Close menu on escape key
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.menuToggle.getAttribute('aria-expanded') === 'true') {
          this.menuToggle.setAttribute('aria-expanded', 'false');
          this.menu.setAttribute('aria-hidden', 'true');
        }
      });

      // Handle mobile submenu toggles
      this.submenuToggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
          const submenuId = toggle.getAttribute('aria-controls');
          const submenu = document.getElementById(submenuId);

          // Toggle aria-expanded
          toggle.setAttribute('aria-expanded', !isExpanded);
          submenu.setAttribute('aria-hidden', isExpanded);
        });
      });
    }
  }

  customElements.define('site-menu', SiteMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["map-section"] && !Shopify.designMode) return;
  try {
    
  class LocationsMap extends HTMLElement {
    constructor() {
      super();
      this.map = null;
      this.markers = [];
      this.locations = [];
      this.activeLocationId = null;
      this.searchLocation = null;
      this.locationClickHandlers = new Map();
    }

    connectedCallback() {
      this.init();
    }

    isMobile() {
      return window.innerWidth < 768; // md breakpoint
    }

    async init() {
      // Load Mapbox GL JS
      await this.loadMapboxResources();

      // Initialize map
      this.initMap();

      // Collect location data
      this.collectLocations();

      // Add markers
      this.addMarkers();

      // Bind events
      this.bindEvents();

      // Bind search events
      this.bindSearchEvents();

      // Bind location button events
      this.bindLocationEvents();

      // Bind resize events
      this.bindResizeEvents();

      // Fit map to show all locations
      this.fitMapToLocations();
    }

    async loadMapboxResources() {
      // Load Mapbox GL JS CSS
      if (!document.querySelector('link[href*="mapbox-gl"]')) {
        const link = document.createElement('link');
        link.href = 'https://api.mapbox.com/mapbox-gl-js/v2.15.0/mapbox-gl.css';
        link.rel = 'stylesheet';
        document.head.appendChild(link);
      }

      // Load Mapbox GL JS
      if (!window.mapboxgl) {
        const script = document.createElement('script');
        script.src = 'https://api.mapbox.com/mapbox-gl-js/v2.15.0/mapbox-gl.js';
        document.head.appendChild(script);

        await new Promise((resolve) => {
          script.onload = resolve;
        });
      }
    }

    initMap() {
      const mapboxContainerId = 'mapbox-map';
      const mapboxContainer = document.getElementById(mapboxContainerId);
      const mapboxToken = mapboxContainer.dataset.token;

      if (!mapboxToken) {
        console.error('Mapbox token is required');
        return;
      }

      this.mapboxToken = mapboxToken;
      mapboxgl.accessToken = mapboxToken;

      this.map = new mapboxgl.Map({
        container: mapboxContainerId,
        style: 'mapbox://styles/mapbox/streets-v12',
        center: [-87.632382, 41.883718], // Center of Chicago
        zoom: 4,
        minZoom: 10,
        maxZoom: 16,
      });

      // Add navigation controls
      this.map.addControl(new mapboxgl.NavigationControl());
    }

    collectLocations() {
      const locationItems = document.querySelectorAll('.location-item');

      locationItems.forEach((item) => {
        const lat = parseFloat(item.dataset.lat);
        const lng = parseFloat(item.dataset.lng);
        const locationId = item.dataset.locationId;

        if (!isNaN(lat) && !isNaN(lng)) {
          this.locations.push({
            id: locationId,
            lat: lat,
            lng: lng,
            element: item,
            distance: null,
          });
        }
      });
    }

    addMarkers() {
      this.locations.forEach((location) => {
        // Create popup content
        const popupContent = this.createPopupContent(location);

        // Create popup
        const popup = new mapboxgl.Popup({
          anchor: 'bottom',
          offset: 40,
          closeButton: true,
          closeOnClick: true,
          maxWidth: '400px',
        }).setHTML(popupContent);

        // Create marker
        const marker = new mapboxgl.Marker({
          color: '#FBB043',
        })
          .setLngLat([location.lng, location.lat])
          .setPopup(popup)
          .addTo(this.map);

        // Add click event to marker
        marker.getElement().addEventListener('click', (e) => {
          e.preventDefault();
          this.selectLocation(location.id, true);
        });

        this.markers.push({
          marker: marker,
          locationId: location.id,
          popup: popup,
        });
      });
    }

    createPopupContent(location) {
      // Clone the location element
      const locationElement = location.element;
      const clonedElement = locationElement.cloneNode(true);

      // Remove classes that are specific to the list layout
      clonedElement.className = '';

      // Remove data attributes and tabindex
      clonedElement.removeAttribute('data-lat');
      clonedElement.removeAttribute('data-lng');
      clonedElement.removeAttribute('data-location-id');
      clonedElement.removeAttribute('tabindex');

      // Add popup-specific styling
      clonedElement.style.padding = '16px';
      clonedElement.style.minWidth = '320px';

      // Make sure links work in popup
      const links = clonedElement.querySelectorAll('a');
      links.forEach((link) => {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      });

      return clonedElement.outerHTML;
    }

    bindEvents() {
      this.updateLocationClickEvents();
    }

    updateLocationClickEvents() {
      // Remove existing event listeners
      this.locationClickHandlers.forEach((handler, element) => {
        element.removeEventListener('click', handler);
      });
      this.locationClickHandlers.clear();

      // Add click events to location items (disabled on mobile)
      if (!this.isMobile()) {
        this.locations.forEach((location) => {
          const handler = () => {
            this.selectLocation(location.id);
            this.flyToLocation(location.lat, location.lng);
          };

          location.element.addEventListener('click', handler);
          this.locationClickHandlers.set(location.element, handler);
        });
      }
    }

    bindResizeEvents() {
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          this.updateLocationClickEvents();
        }, 250); // Debounce resize events
      });
    }

    bindSearchEvents() {
      const searchForm = document.getElementById('location-search-form');
      const searchInput = document.getElementById('location-search-input');
      const searchStatus = document.getElementById('search-status');

      if (searchForm) {
        searchForm.addEventListener('submit', async (e) => {
          e.preventDefault();
          const searchTerm = searchInput.value.trim();

          if (!searchTerm) return;

          searchStatus.textContent = 'Searching...';
          searchStatus.classList.remove('hidden', 'text-primary');
          searchStatus.classList.add('text-gray-600');

          try {
            const coordinates = await this.geocodeLocation(searchTerm);
            if (coordinates) {
              this.searchLocation = coordinates;
              this.centerMapOnSearch(coordinates);
              this.calculateDistancesFromSearch(coordinates);
              this.reorderLocationsByDistance();
              searchStatus.textContent = '';
            } else {
              throw new Error('Location not found');
            }
          } catch (error) {
            searchStatus.textContent = 'Location not found. Please try a different city or zip code.';
            searchStatus.classList.remove('text-gray-600');
            // searchStatus.classList.add('text-primary');
          }
        });
      }
    }

    bindLocationEvents() {
      const useLocationBtn = document.getElementById('use-location-btn');
      const searchStatus = document.getElementById('search-status');

      if (useLocationBtn) {
        useLocationBtn.addEventListener('click', async () => {
          if (!navigator.geolocation) {
            searchStatus.textContent = 'Geolocation is not supported by this browser.';
            searchStatus.classList.remove('hidden', 'text-gray-600');
            // searchStatus.classList.add('text-primary');
            return;
          }

          searchStatus.textContent = 'Getting your location...';
          searchStatus.classList.remove('hidden', 'text-primary');
          searchStatus.classList.add('text-gray-600');

          try {
            const position = await new Promise((resolve, reject) => {
              navigator.geolocation.getCurrentPosition(resolve, reject, {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 300000, // 5 minutes
              });
            });

            const coordinates = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };

            this.searchLocation = coordinates;
            this.centerMapOnSearch(coordinates);
            this.calculateDistancesFromSearch(coordinates);
            this.reorderLocationsByDistance();
            searchStatus.textContent = 'Using your current location';
          } catch (error) {
            let errorMessage = 'Unable to get your location. ';

            switch (error.code) {
              case error.PERMISSION_DENIED:
                errorMessage += 'Please allow location access and try again.';
                break;
              case error.POSITION_UNAVAILABLE:
                errorMessage += 'Location information is unavailable.';
                break;
              case error.TIMEOUT:
                errorMessage += 'Location request timed out.';
                break;
              default:
                errorMessage += 'An unknown error occurred.';
                break;
            }

            // alert(errorMessage);
            searchStatus.textContent = errorMessage;
            searchStatus.classList.remove('text-gray-600');
            // searchStatus.classList.add('text-primary');
          }
        });
      }
    }

    async geocodeLocation(searchTerm) {
      try {
        const response = await fetch(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(searchTerm)}.json?access_token=${this.mapboxToken}&country=US&types=place,postcode`,
        );

        if (!response.ok) {
          throw new Error('Geocoding request failed');
        }

        const data = await response.json();

        if (data.features && data.features.length > 0) {
          const [lng, lat] = data.features[0].center;
          return { lat, lng };
        }

        return null;
      } catch (error) {
        console.error('Geocoding error:', error);
        return null;
      }
    }

    centerMapOnSearch(coordinates) {
      this.map.flyTo({
        center: [coordinates.lng, coordinates.lat],
        duration: 1500,
      });
    }

    calculateDistancesFromSearch(searchCoords) {
      this.locations.forEach((location) => {
        location.distance = this.calculateDistance(searchCoords.lat, searchCoords.lng, location.lat, location.lng);
      });
    }

    calculateDistance(lat1, lng1, lat2, lng2) {
      const R = 3959; // Earth's radius in miles
      const dLat = this.toRadians(lat2 - lat1);
      const dLng = this.toRadians(lng2 - lng1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.toRadians(lat1)) * Math.cos(this.toRadians(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    }

    toRadians(degrees) {
      return degrees * (Math.PI / 180);
    }

    reorderLocationsByDistance() {
      if (!this.searchLocation) return;

      // Sort locations by distance
      const sortedLocations = [...this.locations].sort((a, b) => {
        if (a.distance === null) return 1;
        if (b.distance === null) return -1;
        return a.distance - b.distance;
      });

      // Get the parent container
      const container = document.querySelector('.location-item').parentNode;

      // Remove all location items from DOM
      this.locations.forEach((location) => {
        location.element.remove();
      });

      // Re-append in sorted order and update distance display
      sortedLocations.forEach((location) => {
        // Update distance display
        const distanceElement = location.element.querySelector('.location-distance');
        if (distanceElement && location.distance !== null) {
          const distanceText = `${location.distance.toFixed(1)} miles away`;
          distanceElement.textContent = distanceText;
        } else {
          distanceElement.textContent = '';
        }

        // Re-append to container
        container.appendChild(location.element);
      });

      // Update the locations array to match the new order
      this.locations = sortedLocations;

      // Scroll the location list back to the top
      if (!this.isMobile()) {
        container.scroll({
          top: 0,
          behavior: 'smooth',
        });
      }
    }

    selectLocation(locationId, scrollList = false) {
      // Close all popups except the selected one, then open the selected popup
      this.markers.forEach((markerObj) => {
        if (markerObj.locationId !== locationId) {
          markerObj.popup.remove();
        }
      });

      // Open the selected popup
      const selectedMarker = this.markers.find((markerObj) => markerObj.locationId === locationId);
      if (selectedMarker) {
        selectedMarker.popup.addTo(this.map);
      }

      this.activeLocationId = locationId;
    }

    flyToLocation(lat, lng) {
      this.map.flyTo({
        center: [lng, lat],
        zoom: 12,
        duration: 1000,
      });
    }

    fitMapToLocations() {
      if (this.locations.length === 0) return;

      const bounds = new mapboxgl.LngLatBounds();

      this.locations.forEach((location) => {
        bounds.extend([location.lng, location.lat]);
      });

      this.map.fitBounds(bounds, {
        padding: 50,
        maxZoom: 12,
      });
    }
  }

  customElements.define('locations-map', LocationsMap);

  } catch(e) { console.error(e); }
})();
})();
